import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { LoginService } from '../Services/login.service';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UserModel } from '../Models/user.model';

/**
 * Role-based guard to protect routes based on user roles.
 * Usage: Set required roles in route data: { roles: ['admin', 'manager'] }
 */
export const roleGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: any,
) => {
    const loginService = inject(LoginService);
    const router = inject(Router);
    const requiredRoles = route.data['roles'] as string[];

    return loginService.getCurrentUser().pipe(
        map((user: UserModel) => {
            if (requiredRoles && requiredRoles.includes(user.role)) {
                return true;
            } else {
                router.navigate(['/home']);
                return false;
            }
        }),
        catchError(() => {
            router.navigate(['/login']);
            return of(false);
        }),
    );
};
